import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hourlyRateInput", "hourlyRateMessage", "effectiveAtInput", "effectiveAtMessage"]

  static values = {
    hourlyRateRequired: String,
    hourlyRateInvalid: String,
    effectiveAtRequired: String
  }

  validateOnSubmit(event) {
    const rateOk = this.validateHourlyRate()
    const dateOk = this.validateEffectiveAt()

    if (!(rateOk && dateOk)) event.preventDefault()
  }

  validateHourlyRate() {
    if (!this.hasHourlyRateInputTarget) return true

    const value = this.hourlyRateInputTarget.value.trim()
    const number = Number(value.replace(",", "."))

    if (value.length === 0) {
      this.setFieldState(this.hourlyRateInputTarget, this.hourlyRateMessageTarget, "error", this.hourlyRateRequiredMessage())
      return false
    }

    if (Number.isNaN(number) || number < 0) {
      this.setFieldState(this.hourlyRateInputTarget, this.hourlyRateMessageTarget, "error", this.hourlyRateInvalidMessage())
      return false
    }

    this.setFieldState(this.hourlyRateInputTarget, this.hourlyRateMessageTarget, "clear", "")
    return true
  }

  validateEffectiveAt() {
    if (!this.hasEffectiveAtInputTarget) return true

    const value = this.effectiveAtInputTarget.value

    if (!value) {
      this.setFieldState(this.effectiveAtInputTarget, this.effectiveAtMessageTarget, "error", this.effectiveAtRequiredMessage())
      return false
    }

    this.setFieldState(this.effectiveAtInputTarget, this.effectiveAtMessageTarget, "clear", "")
    return true
  }

  setFieldState(input, message, kind, text) {
    input.classList.remove("border-red-500", "bg-red-50")

    if (kind === "error") {
      input.classList.add("border-red-500", "bg-red-50")
    }

    if (!message) return

    if (kind === "clear") {
      message.textContent = ""
      message.classList.add("hidden")
      return
    }

    message.textContent = text
    message.classList.remove("hidden")
  }

  hourlyRateRequiredMessage() {
    return this.hasHourlyRateRequiredValue ? this.hourlyRateRequiredValue : "Hourly rate is required."
  }

  hourlyRateInvalidMessage() {
    return this.hasHourlyRateInvalidValue ? this.hourlyRateInvalidValue : "Please enter a valid hourly rate greater than or equal to zero."
  }

  effectiveAtRequiredMessage() {
    return this.hasEffectiveAtRequiredValue ? this.effectiveAtRequiredValue : "Effective date is required."
  }
}

